module.exports = __webpack_public_path__ + "img/normal.d9901f36.svg";